module.exports = __webpack_public_path__ + "img/words4.fd8f3c26.png";